module.exports = __webpack_public_path__ + "static/media/flo.7434e4f0.svg";